import type { IconSvgObject } from './types';

const PoopIcon: IconSvgObject = [
  ["path", { d: "M2 18C2 16.067 3.567 14.5 5.5 14.5H18.5C20.433 14.5 22 16.067 22 18C22 19.933 20.433 21.5 18.5 21.5H5.5C3.567 21.5 2 19.933 2 18Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 12C5 10.6193 6.11929 9.5 7.5 9.5H16.5C17.8807 9.5 19 10.6193 19 12C19 13.3807 17.8807 14.5 16.5 14.5H7.5C6.11929 14.5 5 13.3807 5 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 9.5H13C14.6569 9.5 16 8.15685 16 6.5C16 4.5 15 3 13 2.5C13 2.5 14 5.5 12 5.5H10C8.89543 5.5 8 6.39543 8 7.5C8 8.60457 8.89543 9.5 10 9.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PoopIcon;
